/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export interface TimeseriesDto {
  /** Start date-time in UTC (ISO 8601 format) */
  fromDateTimeUtc?: string;
  /** End date-time in UTC (ISO 8601 format) */
  toDateTimeUtc?: string;
  /** Get only the latest timeseries data point for each requested point */
  latestOnly?: boolean;
  /** The name of the timeseries point to filter by. */
  point: string;
}
